// VitrineCapas.js — Faixa contínua de capas ("publicados recentemente").
//
// Inspirada no LogoLoop do react-bits, mas com o propósito invertido: em vez
// de logos de clientes, capas de livros. Numa editora, a capa é o produto —
// esta é a seção onde o acervo aparece pelo tamanho, não pelo detalhe.
//
// Cuidados tomados:
//  - Só entra se houver capas de verdade (>= 6). Faixa curta ficaria repetitiva.
//  - Pausa quando o mouse está em cima, para dar tempo de clicar numa capa.
//  - Para completamente com prefers-reduced-motion (regra global em App.css).
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Marquee from "../ui/Marquee";
import Vitrine from "../produto/vitrine/Vitrine";

const API_URL = process.env.REACT_APP_API;
const main = process.env.REACT_APP_MAIN;

const MINIMO_DE_CAPAS = 6;

const VitrineCapas = () => {
  const [livros, setLivros] = useState([]);

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        // `ebooks-recentes` já vem na ordem de publicação — é exatamente o
        // recorte que a seção promete no título.
        const r = await fetch(API_URL + "ebooks-recentes");
        if (!r.ok) return;
        const data = await r.json();
        if (!ativo || !Array.isArray(data)) return;
        setLivros(data.filter((l) => l?.image).slice(0, 18));
      } catch {
        /* sem capas → seção não aparece */
      }
    })();
    return () => { ativo = false; };
  }, []);

  if (livros.length < MINIMO_DE_CAPAS) return null;

  return (
    // O limite de 1280px e o respiro lateral vêm da moldura (vitrine/Vitrine).
    // A faixa era a única coisa da home que sangrava de ponta a ponta da tela,
    // e em telas largas as capas apareciam soltas nas laterais, fora do bloco
    // em que todo o resto vive.
    <Vitrine
      chapeu="Acervo"
      titulo="Publicados recentemente"
      icone="bi-collection"
      descricao="Os últimos títulos que saíram da editora. Passe o mouse para a faixa parar e clique em qualquer capa."
      verTodos={{ to: main + "livros", texto: "Ver o acervo" }}
    >
      {/* A máscara de fade das bordas mora no Marquee, então a faixa nasce e
          morre dissolvida na margem do bloco — não cortada a seco. */}
      <Marquee velocidade={60}>
        {livros.map((livro) => (
          <Link
            key={livro.id}
            to={main + "livros/" + livro.id}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            title={livro.titulo}
            className="block w-[130px] md:w-[160px] mx-2.5 group/capa"
          >
            {/* A capa ganhou o mesmo acabamento dos cards: contorno de 2px na
                cor da sombra e a sombra sólida deslocada, que cresce quando o
                cursor chega. Era uma borda de hairline e nada mais — do lado
                de cards com relevo, a faixa parecia de outro site. */}
            <div className="rounded-card overflow-hidden bg-insigne-navy-deep aspect-[3/4]
                            border-2 border-insigne-sombra
                            shadow-[3px_3px_0_0_rgb(var(--c-sombra))]
                            transition-[transform,box-shadow,border-color] duration-300
                            group-hover/capa:-translate-x-[2px] group-hover/capa:-translate-y-[2px]
                            group-hover/capa:shadow-[5px_5px_0_0_rgb(var(--c-sombra))]
                            group-hover/capa:border-insigne-orange">
              <img
                src={`${API_URL}public/${livro.image}`}
                alt={livro.titulo}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </Link>
        ))}
      </Marquee>
    </Vitrine>
  );
};

export default VitrineCapas;
